import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1adb5d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sponsors-banner" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = ["src"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.computedSponsors.SponsorsLogosTitle), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedSponsors.SponsorsLogos, (logo, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "sponsor",
        key: index
      }, [
        _createElementVNode("img", {
          src: logo.ImageUrl
        }, null, 8, _hoisted_3)
      ]))
    }), 128))
  ]))
}